import type { Block, PublicationBlock } from "../types";
import { wooProduct } from "../wordpress";

/**
 * Sobrepõe capa, título e link com o produto real do WooCommerce quando o
 * slug existe no catálogo; fora do WordPress (ou sem produto correspondente)
 * mantém o dado fixo abaixo.
 */
function withProduct(
	slug: string,
	block: PublicationBlock,
	preserveCover = false,
): PublicationBlock {
	const product = wooProduct(slug);
	if (!product) return block;

	return {
		...block,
		title: product.title,
		href: product.href,
		cover: preserveCover ? block.cover : product.image || block.cover,
	};
}

/** Mosaico da secção "llibres": as três publicacions do catálogo. */
export const homeBlocks: Block[] = [
	withProduct("50-tacus", {
		kind: "publication",
		id: "50-tacus",
		title: "50 Tacus",
		description:
			"Construït a partir de fragments, llegit com un tot: cinquanta talls d’una mateixa fusta.",
		category: "llibres",
		genre: "narrativa",
		cover: "/assets/50-tacus.jpg",
		href: "/producte/50-tacus/",
		color: "#f6dccd",
	}),
	withProduct("cartografia-de-lestrany-mapa-i-finestres", {
		kind: "publication",
		id: "cartografia",
		title: "Cartografia de l’estrany",
		description:
			"Mapa I: Finestres. Setze veus catalanes travessen l’insòlit en un atles portàtil.",
		category: "llibres",
		genre: "narrativa",
		cover: "/assets/finesterres.jpeg",
		href: "/producte/cartografia-de-lestrany-mapa-i-finestres/",
		color: "#f8edbd",
	}),
	withProduct("pur-nara-vidal", {
		kind: "publication",
		id: "pur",
		title: "Pur",
		description:
			"Nara Vidal. El Brasil dels anys 30 esdevé el laboratori d’una eugenèsia cruel disfressada de ciència.",
		category: "llibres",
		genre: "narrativa",
		cover: "/assets/MOCKUPS_LIVROS/PUR_COSANOVA.png",
		href: "/producte/pur-nara-vidal/",
		color: "#e7e6e0",
		tag: "pre-venda",
	}, true),
];
